/*
 * Public API of v-wrappers
 */
export * from './lib/wrappers.module';
export * from './lib/wrapper.interface';


